<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">提案元商品検索</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <button class="btn-secondary" (click)="eventSearch_CLICKHandler()"> 商品検索 </button>
          <div class="action-area">
            <app-pager [prevDisabled]="!model.pagenation.btnBackEnabled()"
              [nextDisabled]="!model.pagenation.btnNextEnabled()" [totalNum]="model.pagenation.totalNum"
              [startNum]="model.pagenation.startDispNum" [endNum]="model.pagenation.endDispNum"
              (prevHandler)="eventBack_CLICKHandler()" (nextHandler)="eventNext_CLICKHandler()">
            </app-pager>
          </div>
          <wj-flex-grid #dtg_GoodsList [itemsSource]="model.goodsList" class="space-bottom" [tabindex]="0"
            id="dtg_GoodsList" [headersVisibility]="'Column'" [isReadOnly]="true" [allowSorting]="false"
            [selectionMode]="'Row'" [deferResizing]="false" [allowDragging]="'None'" [style.height.px]="500" [style.width.px]="1008">
            <wj-flex-grid-column [minWidth]="5" [width]="50" [header]="' '" [align]="'center'" [isReadOnly]="true">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item = "item">
                <input type="radio" [value] ="item.id" [(ngModel)]="model.selectedRowIndex" [tabindex]="0"  [name]="'group' + item.id"/>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'商品名'" [width]="370" [binding]="'goodsName'"
              [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'規格名'" [width]="230" [binding]="'standardName'"
              [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'JANコード'" [width]="140" [binding]="'janCode'"
              [isReadOnly]="true">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'バイヤー'" [width]="200" [binding]="'buyerName'"
              [isReadOnly]="true">
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Copy" class="btn-primary" (click)="eventCopy_CLICKHandler()" [tabindex]="0">コピー</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>

</table>